import CloseIcon from '@mui/icons-material/Close';
import { Grow } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { forwardRef } from 'react';
import { DialogStyled } from './DialogStyled';

type Props = {
  children: React.ReactNode;
  open: boolean;
  onClose: (xButtonClose?: boolean) => void;
  showCloseButton?: boolean;
  customMaxWidth?: number;
  closeOnOutsideClick?: boolean;
};

/**
 * ModalStyled is a styled version of the Dialog component.
 * It adds a close button to the top right of the modal and a
 * generic transition component that's used on most, if not all, dialogs anyways.
 */
export const ModalStyled = ({
  children,
  showCloseButton = true,
  customMaxWidth,
  closeOnOutsideClick = true,
  open,
  ...props
}: Props) => {
  const handleClose = (
    event: {},
    reason: 'backdropClick' | 'escapeKeyDown',
  ) => {
    // only close the modal on outside clicks if closeOnOutsideClick is true (default is true)
    if (reason === 'backdropClick' && !closeOnOutsideClick) {
      return;
    }
    props.onClose();
  };

  return (
    <DialogStyled
      {...props}
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      customMaxWidth={customMaxWidth}
    >
      {showCloseButton && (
        <div
          onClick={() => props.onClose(true)}
          className='absolute right-3 top-2.5 z-50 cursor-pointer fill-darkSteel hover:fill-gray-400'
        >
          <CloseIcon
            className='transition-all'
            style={{ fontSize: '24px', fill: 'inherit' }}
          />
        </div>
      )}
      {children}
    </DialogStyled>
  );
};

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Grow ref={ref} {...props} />;
});
